import { createStore, combineReducers, applyMiddleware, Middleware } from "redux"
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { systemReducer } from "./system/reducers"
import { userReducer } from "./user/reducers";
import { organizationReducer } from "./organization/reducers";

const rootReducer = combineReducers({
  system: systemReducer, 
  user:userReducer,
  organization: organizationReducer
});
export type AppState = ReturnType<typeof rootReducer>;
export default function configureStore() {
  const middlewares: Middleware[] = [thunkMiddleware]; 
  const middleWareEnhancer = applyMiddleware(...middlewares);
  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );
  return store;
}

